"use client";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

function CompanyOverviewSection({ sectionSpace = "py-5" }) {
  // Unsplash high-resolution architecture & real estate images
 const images = {
  mainExterior: "/img/team/about-main.webp",
  interiorDetail: "/img/team/about-real-estate.webp",
  architecturalFacade: "/img/team/about-trusted.webp",
};

  return (
    <section
      className={`ltn__about-us-area ${sectionSpace}`}
      style={{
        backgroundColor: "#f2f6f7",
        position: "relative",
      }}
    >
      <Container>
        <Row className="align-items-center g-5">
          {/* Left Column: Complete Text Content */}
          <Col xs={12} lg={6}>
            <div className="cos-content-wrap">
              <span className="cos-kicker">Trusted Real Estate Developers in Nagpur</span>

              <h2 className="cos-title">
                Siddhivinayak Group – Creating Quality Homes &amp; Smart
                Investments in Nagpur
              </h2>

              <p className="cos-body">
                Siddhivinayak Group, a distinguished venture of the Kunal Padole Group,
                is one of the trusted real estate developers in Nagpur, known for delivering 
                quality residential projects that combine superior construction, contemporary architecture, 
                strategic locations, and long-term investment value.
              </p>

              <p className="cos-body">
                In today’s evolving real estate market, homebuyers seek more than just a property—they look 
                for trust, security, comfort, convenience, and lasting value. Siddhivinayak Group understands 
                these needs and develops thoughtfully planned residential properties in Nagpur designed for modern lifestyles and future growth.
              </p>

              <p className="cos-body">
                Built on a foundation of trust, transparency, and customer satisfaction, every project reflects careful planning, innovative design, 
                quality construction, and disciplined execution. Our strategically located residential projects in Nagpur provide convenient access 
                to essential amenities, schools, healthcare facilities, commercial hubs, and major infrastructure.
              </p>

              <p className="cos-body">
                As Nagpur continues to develop as a leading Smart City in India, Siddhivinayak Group remains committed to creating modern homes and
                valuable real estate investment opportunities in Nagpur, while building lasting relationships with homeowners and investors.
              </p>

              {/* Stats Row */}
              <div className="cos-stats-grid">
              </div>
            </div>
          </Col>

          {/* Right Column: Architectural Bento Image Grid */}
          <Col xs={12} lg={6}>
            <div className="cos-bento-grid">
              {/* Main Feature Image */}
              <div className="cos-bento-main">
                <img
                  src={images.mainExterior}
                  alt="Siddhivinayak Group Luxury Residential Elevation"
                  className="cos-bento-img"
                />
              </div>

              {/* Stacked Secondary Images */}
              <div className="cos-bento-stack">
                <div className="cos-bento-sub">
                  <img
                    src={images.interiorDetail}
                    alt="Modern Living Space Interior"
                    className="cos-bento-img"
                  />
                </div>
                <div className="cos-bento-sub">
                  <img
                    src={images.architecturalFacade}
                    alt="Contemporary Architectural Facade"
                    className="cos-bento-img"
                  />
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      <style jsx>{`
        .cos-content-wrap {
          padding-right: 12px;
        }

        .cos-kicker {
          display: inline-block;
          font-size: 14px;
          font-weight: 600;
          letter-spacing: 2.5px;
          color: #9c5a12;
          margin-bottom: 12px;
        }

        .cos-title {
          font-size: 30px;
          font-weight: 700;
          line-height: 1.3;
          color: #0f172a;
          letter-spacing: -0.4px;
          margin-bottom: 20px;
        }

        .cos-body {
          font-size: 14.5px;
          line-height: 1.75;
          color: #475569;
          margin-bottom: 16px;
          text-align: justify;
        }

        /* Metrics Grid */
        .cos-stats-grid {
          display: grid;
          grid-template-columns: repeat(2, 1fr);
          gap: 24px;
          padding-top: 20px;
          margin-top: 24px;
          border-top: 1px solid #cbd5e1;
        }

        .cos-stat-block {
          display: flex;
          flex-direction: column;
        }

        .cos-stat-number {
          font-size: 28px;
          font-weight: 800;
          color: #9c5a12;
          line-height: 1;
        }

        .cos-stat-label {
          font-size: 12px;
          font-weight: 600;
          text-transform: uppercase;
          letter-spacing: 0.5px;
          color: #64748b;
          margin-top: 6px;
        }

        /* Bento Grid */
        .cos-bento-grid {
          display: grid;
          grid-template-columns: 1.35fr 1fr;
          gap: 12px;
          height: 520px;
        }

        .cos-bento-main {
          height: 100%;
          border-radius: 10px;
          overflow: hidden;
          background-color: #e2e8f0;
        }

        .cos-bento-stack {
          display: grid;
          grid-template-rows: 1fr 1fr;
          gap: 12px;
          height: 100%;
        }

        .cos-bento-sub {
          height: 100%;
          border-radius: 10px;
          overflow: hidden;
          background-color: #e2e8f0;
        }

        .cos-bento-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
          transition: transform 0.4s ease;
        }

        .cos-bento-main:hover .cos-bento-img,
        .cos-bento-sub:hover .cos-bento-img {
          transform: scale(1.03);
        }

        /* Footer Bar */
        .cos-footer-bar {
          background-color: #ffffff;
          border: 1px solid #e2e8f0;
          border-left: 4px solid #d97706;
          border-radius: 8px;
          padding: 18px 24px;
          box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
        }

        .cos-footer-text {
          margin: 0;
          font-size: 15px;
          color: #334155;
          line-height: 1.5;
        }

        .cos-footer-text strong {
          color: #0f172a;
        }

        @media (max-width: 991px) {
          .cos-content-wrap {
            padding-right: 0;
          }
          .cos-title {
            font-size: 26px;
          }
          .cos-bento-grid {
            height: 400px;
          }
        }

        @media (max-width: 575px) {
          .cos-bento-grid {
            grid-template-columns: 1fr;
            height: auto;
          }
          .cos-bento-main {
            height: 260px;
          }
          .cos-bento-stack {
            grid-template-columns: 1fr 1fr;
            grid-template-rows: 1fr;
            height: 150px;
          }
        }
      `}</style>
    </section>
  );
}

export default CompanyOverviewSection;